import { IMeetingBusy } from "../models/response/meeting/IMeetingBusy";
import { IMeetingPick } from "../models/response/meeting/IMeetingPick";
import { apiClient } from "./apiClient";

export const meetingPickApi = {
    insert: (payload: IMeetingPick) => apiClient.post('meeting-teacher-student-pick', payload),
    update: (payload: IMeetingPick) => apiClient.put('meeting-teacher-student-pick', payload),
    select: (nam_hoc: string, hoc_ky: number) => apiClient.get("meeting-teacher-student-pick/nam-hoc/" + nam_hoc + "/hoc-ky/" + hoc_ky),
    selectByGv: (nam_hoc: string, hoc_ky: number) => apiClient.get("meeting-teacher-student-pick/gv/nam-hoc/" + nam_hoc + "/hoc-ky/" + hoc_ky),
    detail: (id: number) => apiClient.get("meeting-teacher-student-pick/" + id.toString()),
    delete: (id: number) => apiClient.delete("meeting-teacher-student-pick/" + id.toString()),
}